import React, { useState } from "react"
import BaseModal from "../../../components/layout/BaseModal"
import { useQuery } from "@tanstack/react-query"
import { getTimeTrackingReportByEmployee } from "../api/apiCalls"
import { GeneralQueryKeys } from "../../../api/constants"
import BaseInputField from "../../../components/elements/BaseInputField"
import dayjs from "dayjs"
import ErrorPage from "../../404/ErrorPage"
import Loading from "../../../components/common/Loading"
import { minutesToHoursAndMinutes } from "../../../services/functions"

export default function TimetrackingModal(props: { modalId: number; id: string }) {
    const [startDate, setStartDate] = useState<Date>(new Date(new Date().getFullYear(), 0, 1))
    const [endDate, setEndDate] = useState<Date>(new Date())

    const { data, error, isLoading } = useQuery({
        queryKey: [GeneralQueryKeys.TIMETRACKING + props.id],
        queryFn: () => getTimeTrackingReportByEmployee(props.id, startDate, endDate),
    })

    console.log(data)

    return (
        <BaseModal title="Zeiterfassung" modalId={props.modalId}>
            <div className="flex flex-row w-full justify-end gap-2 pt-2">
                <BaseInputField
                    label="Startdatum"
                    type="date"
                    onChange={(e: string) => setStartDate(new Date(e))}
                    value={dayjs(startDate).format("YYYY-MM-DD")}
                />
                <BaseInputField
                    label="Enddatum"
                    type="date"
                    onChange={(e: string) => setEndDate(new Date(e))}
                    value={dayjs(endDate).format("YYYY-MM-DD")}
                />
            </div>

            <div className="flex flex-col">
                <div className="flex flex-row justify-between border-b border-gray-200 py-2">
                    <p className="text-sm font-bold">Zeiterfassung</p>
                    <p className="text-sm font-bold">
                        Gesamt:{" "}
                        {minutesToHoursAndMinutes(
                            data?.reduce(
                                (acc: number, curr: TimeTrackingElementType) => acc + (curr.end ? dayjs(curr.end).diff(curr.start, "minutes") : 0),
                                0
                            )
                        )}
                    </p>
                </div>
                <div className="flex flex-col grow overflow-y-auto max-h-[32rem]">
                    {error && <ErrorPage />}
                    {isLoading && <Loading />}
                    {!error && !isLoading && data?.length === 0 && <p className="text-center text-gray-500">Keine Zeiterfassung gefunden</p>}
                    {!error &&
                        !isLoading &&
                        data?.map((element: TimeTrackingElementType) => <TimeTrackingElement key={element.date.toString()} {...element} />)}
                </div>
            </div>
        </BaseModal>
    )
}

type TimeTrackingElementType = {
    date: Date
    start: Date
    end?: Date
    note?: string
}

function TimeTrackingElement(props: TimeTrackingElementType) {
    return (
        <div className="flex text-xs flex-row w-full justify-between border-b border-gray-200 py-3 gap-2">
            <p className="w-1/4">{dayjs(props.date).format("DD.MM.YYYY")}</p>
            <p className="w-1/4">Start: {dayjs(props.start).format("HH:mm")} Uhr</p>
            <p className="w-1/4">Ende: {props.end ? dayjs(props.end).format("HH:mm") : ""} Uhr</p>
            <p className="w-1/4">Gesamt: {props.end ? minutesToHoursAndMinutes(dayjs(props.end).diff(props.start, "minutes")) : ""}</p>
            <p className="w-1/2">Notiz: {props.note ?? "-"}</p>
        </div>
    )
}
